import { createStore } from 'vuex'
import {user} from "@/store/user";
import {tags} from "@/store/tags";
import {partners} from "@/store/partners";
import {clientLogos} from "@/store/clientLogos";

export default createStore({
  state: {
    isGlobalLoading: false,
    isCRUDLoading: false,

    $isMobile: false,

    activeAlert: {
      timer: null,
      text: 'text-alert',
      type: 'error',
      state: false
    },

    isActiveModal: false,
    isActiveModalName: null,
    timerModal: null,
  },
  getters: {
    isActiveModal: state => state.isActiveModal,
    isCRUDLoading: state => state.isCRUDLoading,
    isActiveModalName: state => state.isActiveModalName,
  },
  mutations: {
    SET_ACTIVE_ALERT: (state, payload) => {
      if(state.activeAlert.timer) {
        clearTimeout(state.activeAlert.timer)
      }
      state.activeAlert = {
        ...state.activeAlert,
        ...payload
      }
      state.activeAlert.timer = setTimeout(() => {
        state.activeAlert.state = false
      },4000)
    },
    SET_CLOSE_ALERT: (state, payload) => {
      if(state.activeAlert.timer) {
        clearTimeout(state.activeAlert.timer)
      }
      state.activeAlert.state = false
    },

    SET_IS_GLOBAL_LOADING: (state, payload) => {
      state.isGlobalLoading = payload
    },
    SET_IS_CRUD_LOADING: (state, payload) => {
      state.isCRUDLoading = payload
    },
    SET_IS_MOBILE: (state, payload) => {
      state.$isMobile = payload
    },

    SET_TIMER_MODAL: (state, payload) => {
      clearTimeout(state.timerModal)
      state.timerModal = payload
    },

    SET_MODAL: (state, payload) => {
      clearTimeout(state.timerModal)
      if(payload?.loading !== undefined) {
        state.isActiveModalName = {...state.isActiveModalName, ...payload}
      } else {
        state.isActiveModalName = payload
      }
      state.isActiveModal = payload !== null
    },
  },
  actions: {
    IS_GLOBAL_LOADING: (context, payload) => {
      context.commit('SET_IS_GLOBAL_LOADING', payload)
    },
    IS_CRUD_LOADING: (context, payload) => {
      context.commit('SET_IS_CRUD_LOADING', payload)
    },

    IS_MOBILE: (context, payload) => {
      context.commit('SET_IS_MOBILE', payload)
    },
    ACTIVE_ALERT: (context, payload) => {
      context.commit('SET_ACTIVE_ALERT', payload)
    },
    CLOSE_ACTIVE_ALERT: (context, payload) => {
      context.commit('SET_CLOSE_ALERT', payload)
    },

    MODAL: (context, payload) => {
      context.commit('SET_MODAL', payload)
    },
    TIMER_MODAL: (context, payload) => {
      context.commit('SET_TIMER_MODAL', payload)
    },
  },
  modules: {
    user: user,
    tags: tags,
    partners: partners,
    clientLogos: clientLogos,
  }
})
